'use client';

// import RatingStars from '@/components/ui/ratings';
import React, { useEffect, useState } from 'react';
import Options from '../options/options';
import Button from '@/components/ui/button';
import Chat from '../chat_now';
import ImageGallery from '../gallery/image_gallery';
const StoreModal = dynamic(
  () => import('@/components/store_locator/store_modal')
);
// import AccessoryPopup from '@/components/checkout/AccessoryPopup';
import { useModalStore } from '@/helpers/modal_store';
import { useVariantPrice } from '@/helpers/variant_price';
import Image from 'next/image';
import { Product } from '@/types/product_page/productType';
import { Minus, Plus } from '@phosphor-icons/react';
import { StoreProduct } from '@medusajs/types';
import { OnlineStore } from '@/types/storesType';
import OnlineStoresList from '../online_stores_list';
// import { RelatedProducts } from '@/types/product_page/productType';
// import { useMedusaCart } from '@/helpers/ecomm_cart';
// import { useAuth } from '@/helpers/user_store';
import { usePostHogEvents } from '@/hooks/usePostHogEvents';
import dynamic from 'next/dynamic';
import { useParams, useSearchParams } from 'next/navigation';
import { localizeHtmlLinks } from '@/lib/utils';

const ProductDescription = ({
  data,
  medusaProd,
  stores,
  chatContent,
  variantOrders,
}: {
  data: Product;
  medusaProd: StoreProduct | null;
  stores?: OnlineStore[] | null;
  chatContent?: any;
  variantOrders?: {
    variant_title: string;
    sort: number;
  }[];
}) => {
  const params = useParams<{ countryCode?: string }>();
  const { isModalOpen, toggleModal } = useModalStore();
  const [lastValidIndex, setLastValidIndex] = useState<number>(0);
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [activeIndex, setActiveIndex] = useState<any>(true);
  const { setPrice } = useVariantPrice();
  const { sendWhereToBuyEvent } = usePostHogEvents();
  const searchParams = useSearchParams();

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY);
      setTimeout(() => {
        setScrolling(window.scrollY > scrollTop);
      }, 700);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollTop]);

  const publishedVariants = data?.variants.filter(
    (v) => v.status === 'published'
  );

  const [selectedOptions, setSelectedOptions] = useState<
    Record<string, string>
  >(() => {
    const initialOptions: Record<string, string> = {};

    data.options.forEach((option) => {
      const paramValue = searchParams.get(option.title);
      if (paramValue) {
        initialOptions[option.title] = paramValue;
      }
    });

    const firstInStockVariant = publishedVariants.find(
      (variant) => variant.inventory_quantity > 0
    );

    if (firstInStockVariant?.option_values && data?.options) {
      firstInStockVariant.option_values.forEach((value) => {
        const optionTitle = data.options.find(
          (option) => option.id === value.option
        )?.title;
        if (optionTitle) {
          initialOptions[optionTitle] = value.value || '';
        }
      });
    }
    return initialOptions;
  });

  const getMatchingVariantIndex = () => {
    return publishedVariants.findIndex((variant) =>
      variant.option_values.every(
        (optionValue) =>
          selectedOptions[
            data.options.find((option) => option.id == optionValue.option)
              ?.title!
          ] === optionValue.value
      )
    );
  };

  useEffect(() => {
    const matchingIndex = getMatchingVariantIndex();
    if (matchingIndex >= 0) {
      setLastValidIndex(matchingIndex);
      setPrice(publishedVariants[matchingIndex]?.rrp);
    }
  }, [selectedOptions]);

  // const [rating, setRating] = useState('0');

  // useEffect(() => {
  //   let totalRating = 0;
  //   data.reviews.forEach((review) => {
  //     totalRating += review.rating;
  //   });
  //   setRating((totalRating / data.reviews.length).toFixed(1));
  // }, [data]);

  const handleSelect = (optionTitle: string, value: string) => {
    setSelectedOptions((prev) => ({ ...prev, [optionTitle]: value }));
  };

  useEffect(() => {
    toggleModal(false);
  }, []);

  const extractPoints = (richText: string) => {
    // Split the text by newline (\n) and clean each point
    const plainText = richText?.replace(/<[^>]+>/g, '');

    return plainText
      ?.split('\n') // Split into array by newline
      .map((point) => point.trim()) // Trim whitespace
      .filter((point) => point) // Remove empty lines
      .map((point) => (point.startsWith('- ') ? point.slice(2) : point)); // Remove '- ' if present
  };

  const extractInTheBox = (richText: string) => {
    // Remove HTML tags using a regular expression
    const plainText = richText?.replace(/<[^>]+>/g, '');

    // Split into array by newline, trim whitespace, and remove empty lines
    return plainText
      ?.split('\n')
      .map((point) => point.trim())
      .filter((point) => point);
  };

  return (
    <>
      <ImageGallery data={publishedVariants[lastValidIndex]?.gallery_items} />

      <aside className="w-full flex flex-col gap-5 lg:pr-8">
        <div
          className={`sticky ${scrolling && window.scrollY > 700 ? 'top-8' : 'top-20'} transition-all duration-200 w-full flex flex-col gap-5 justify-start `}
        >
          <div className="w-full rounded-lg flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <p className="font-semibold">{data?.sub_title}</p>
              <h1 className="text-3xl font-bold">
                {publishedVariants[lastValidIndex]?.title}
              </h1>
              {/* {!!Number(rating) && (
                <div className="text-xs flex gap-2 items-center font-medium">
                  <RatingStars rating={Number(rating)} />
                  <p className="opacity-80">{data.reviews?.length} reviews</p>
                </div>
              )} */}
              <h3
                style={{ WebkitTextSizeAdjust: '100%' }}
                className="product-price text-3xl font-bold py-1"
              >
                ${publishedVariants[lastValidIndex]?.rrp}
              </h3>
            </div>
            <div className="text-base font-medium text-black font-proxima_font">
              <div
                dangerouslySetInnerHTML={{
                  __html: localizeHtmlLinks(
                    data?.product_description,
                    params?.countryCode
                  ),
                }}
                className="disc-points text-off-black font-proxima_font text-base"
              ></div>
              <ul className="text-off-black mt-1 ml-[14px] list-disc font-proxima_font text-base">
                {extractPoints(data?.key_features)?.map((item, idx) => {
                  return (
                    <li
                      dangerouslySetInnerHTML={{ __html: item }}
                      key={idx}
                    ></li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className="flex flex-col w-full bg-white">
            {!!data?.options.length && (
              <Options
                onSelect={handleSelect}
                selectedOptions={selectedOptions}
                variants={publishedVariants}
                options={data.options}
                sizeModal={data.size_guide}
                variantOrders={variantOrders}
                slug={data?.handle}
              />
            )}
            <div className="pb-6 border-b border-gray">
              <p className="font-semibold">
                <span className="font-semibold">SKU:</span>{' '}
                {publishedVariants[lastValidIndex]?.sku}
              </p>
            </div>

            {!!data?.in_the_box && (
              <div className="w-full mx-auto font-proxima_font">
                <div className="py-6 border-b border-border-gray">
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    onClick={() => setActiveIndex(!activeIndex)}
                  >
                    <span className="font-semibold">In the box:</span>
                    <span>
                      {activeIndex ? (
                        <Minus strokeWidth={2} size={20} />
                      ) : (
                        <Plus strokeWidth={2} size={20} />
                      )}
                    </span>
                  </div>
                  <div
                    className={`bg-white transition-all duration-300 ${
                      activeIndex
                        ? 'max-h-[1000px] pt-3'
                        : 'max-h-0 overflow-hidden'
                    }`}
                  >
                    <ul className="in-the-box text-base text-off-black font-medium font-proxima_font">
                      {extractInTheBox(data?.in_the_box)?.map((item, idx) => (
                        <li
                          key={idx}
                          dangerouslySetInnerHTML={{ __html: item }}
                          className="list-inside list-disc"
                        ></li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {data?.additional_text && (
              <div
                className="pt-8 font-proxima_font"
                dangerouslySetInnerHTML={{
                  __html: localizeHtmlLinks(
                    data?.additional_text,
                    params?.countryCode
                  ),
                }}
              ></div>
            )}

            {data?.buy_cta && (
              <div
                id="buy-section"
                className="flex flex-col-reverse md:flex-row gap-3 mb-3 mt-8"
              >
                <Button
                  variant="fill"
                  animation="none"
                  label="Where To Buy"
                  className="w-full flex-1 border-black border"
                  icon="/icons/shopping-cart-fill.svg"
                  onClick={() => {
                    (toggleModal(true),
                      sendWhereToBuyEvent(data?.id, data?.title));
                  }}
                />
              </div>
            )}
          </div>

          <OnlineStoresList online_stores={stores || []} />

          {data?.highlights.length > 0 && (
            <div className="w-full p-4 mb-1 font-proxima_font bg-off-white text-off-black grid grid-cols-1 md:grid-cols-2 gap-y-2 rounded-xl">
              {data.highlights?.map((point, index) => (
                <div
                  key={point.product_highlight_translations_id.id}
                  className="flex items-center gap-3"
                >
                  <Image
                    src={
                      point.product_highlight_translations_id.icon
                        ? `${process.env.NEXT_PUBLIC_BASE_URL}/assets/${point.product_highlight_translations_id.icon}`
                        : '/icons/shield.png'
                    }
                    alt="Icon"
                    width={50}
                    height={50}
                    className="size-5"
                  />
                  <p className="text-[16px]">
                    {point.product_highlight_translations_id.highlight}
                  </p>
                </div>
              ))}
            </div>
          )}
          {/* Chat banner */}
          <Chat content={chatContent} data={data} />
        </div>
      </aside>

      {isModalOpen && (
        <StoreModal
          isOpen={isModalOpen}
          onClose={() => toggleModal(false)}
          online_stores={stores || []}
        />
      )}
    </>
  );
};

export default ProductDescription;
